import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { TSummary, TSubscription, SubscriptionsState } from 'store/subscriptions/types';

export const getSubscriptionsState = (state: RootState): SubscriptionsState => state.subscriptions;

export const getSubscriptionsData = createSelector(
  [getSubscriptionsState],
  (state: SubscriptionsState): TSubscription[] =>
    !state?.data?.subscriptions
      ? state?.data?.subscriptions
      : state?.data?.subscriptions?.map(subscription => ({
          ...subscription,
          amount: subscription?.amount / 100,
        }))
);

export const getSubscriptionsSummary = createSelector(
  [getSubscriptionsState],
  (state: SubscriptionsState): TSummary =>
    !state?.data?.summary
      ? state?.data?.summary
      : {
          ...state?.data?.summary,
          total_active_amount: state?.data?.summary?.total_active_amount / 100,
        }
);
